import React, { Component } from "react";

import Form from '@rjsf/antd';
import validator from '@rjsf/validator-ajv8';
import { bucketSchema, bucketUiSchema, AddButton, RemoveButton } from "./BucketSchema";

// import { Loader, ErrorBannerMessage } from '@ttd/lingo';
import { Alert, Spin, Modal } from 'antd';

import PropTypes from 'prop-types';




class AddBucket extends Component {
  constructor() {
    super();
    this.state = {
    };

    this.form = React.createRef();
    this.submit_form = this.submit_form.bind(this);
  }


  submit_form({ formData }, e) {
    e.preventDefault();
    this.props.save_new_bucket(formData);
  }




  render() {
    return (
      <div>
        <h1>Onboard New Project</h1>
        {this.state.saving &&
          <div>
             {/* <Loader /> */}
             <Spin spinning={this.state.saving} fullscreen />

            <h3>Saving...</h3>
          </div>
        }

        {this.props.show_error &&
              <Modal
                open={this.props.show_error}>
                <Alert
                  message={this.props.error_message}
                  type="error"
                  banner
                />
              </Modal>
        }

        <Form
          disabled={this.state.saving}
          schema={bucketSchema}
          uiSchema={bucketUiSchema}
          ref={this.form}
          validator={validator}
          onSubmit={this.submit_form}
          templates={{ ButtonTemplates: { AddButton:AddButton, RemoveButton:RemoveButton } }} />
      </div>
    );
  }
}

AddBucket.propTypes = {
    show_error: PropTypes.bool,
    error_message: PropTypes.string,
    save_new_bucket: PropTypes.func,
};
export default AddBucket;
